import { AxiosPromise } from 'axios';

import { ISearch } from '~/components/Pagination/Search';
import { IPagination, IPackage } from '~/models/Common';
import {
  IContract,
  IUserContract,
  IUserContractRequiredForm,
  IUserEditContractRequiredForm,
} from '~/models/Contracts';
import {
  IProfessional,
  IProfessionalForm,
  IUser,
  IUserCadasterRequiredForm,
} from '~/models/User';

import api from './api';

const ContractsService = {
  getAllContracts(professionalId: string): AxiosPromise<IUserContract[]> {
    return api.get(`/admin/professional/${professionalId}/contract/index`);
  },

  getOneContract(contractId: string): AxiosPromise<IUserContract[]> {
    return api.get(`/admin/professional/contract/${contractId}/show`);
  },

  createContract(
    professionalId: string,
    data: IUserContractRequiredForm,
  ): AxiosPromise<IContract> {
    return api.post(
      `/admin/professional/${professionalId}/contract/create`,
      data,
    );
  },

  validateContractActive(
    professionalId: string,
  ): AxiosPromise<{ message: string; contract_number?: number }> {
    return api.get(`/admin/professional/${professionalId}/contract/validate`);
  },

  editContract(
    contractId: string,
    data: IUserEditContractRequiredForm,
  ): AxiosPromise {
    return api.put(`/admin/professional/contract/${contractId}/update`, data);
  },

  createProfessional(data: IProfessionalForm): AxiosPromise<IProfessional> {
    return api.post('/auth/admin/signup/professional', data);
  },

  deleteUser(userId: string): AxiosPromise {
    return api.delete(`users/${userId}`);
  },

  updateUser(
    userId: string,
    professionalId: number,
    status: boolean,
  ): AxiosPromise {
    return api.put(`/gyms/${userId}/professionals/${professionalId}`, {
      status,
    });
  },

  getUserPackages(
    userId: string,
    data: ISearch,
  ): AxiosPromise<IPagination<IPackage[]>> {
    return api.get(`packages/professional/${userId}/all`, {
      params: data,
    });
  },

  getProfessionalStudents(
    professionalId: number,
    page: number,
    perpage = 9,
    search?: string,
    planStatus?: string,
    paymentStatus?: string,
    startDate?: string,
  ): AxiosPromise<IPagination<IUser[]>> {
    return api.get(`/admin/professional/${professionalId}/student`, {
      params: { page, perpage, search, planStatus, paymentStatus, startDate },
    });
  },

  editUserPackage(packageId: string, data: IPackage): AxiosPromise {
    return api.put(`packages/${packageId}`, data);
  },

  deleteUserPackage(packageId: string): AxiosPromise {
    return api.delete(`packages/${packageId}`);
  },
};

export default ContractsService;
